module.exports = __WEBPACK_EXTERNAL_MODULE_18__;


//////////////////
// WEBPACK FOOTER
// external {"root":["rx","Subject"],"commonjs":"rxjs/Subject","commonjs2":"rxjs/Subject","amd":"rxjs/Subject"}
// module id = 18
// module chunks = 0